import React from 'react';
import AdminLayout from '../AdminLayout';
import './AdminDashboard.css';

const AdminDashboard = () => {
  return (
    <AdminLayout>
      <div className="admin-dashboard">
      <header className="dashboard-header">
        <h1>Admin Dashboard</h1>
        <p>Welcome to the Densat Admin Panel</p>
      </header>

      <div className="dashboard-stats">
        <div className="stat-card">
          <h3>Total Services</h3>
          <p className="stat-number">12</p>
        </div>
        <div className="stat-card">
          <h3>Active Users</h3>
          <p className="stat-number">1,234</p>
        </div>
        <div className="stat-card">
          <h3>Pending Requests</h3>
          <p className="stat-number">56</p>
        </div>
        <div className="stat-card">
          <h3>Revenue</h3>
          <p className="stat-number">$45,678</p>
        </div>
      </div>

      <div className="dashboard-content">
        <div className="recent-activity">
          <h2>Recent Activity</h2>
          <ul>
            <li>New service request from Corporate Client</li>
            <li>User John Doe updated profile</li>
            <li>Blog post "Cleaning Tips" published</li>
            <li>System maintenance completed</li>
          </ul>
        </div>

        <div className="quick-actions">
          <h2>Quick Actions</h2>
          <button className="action-btn">Add New Service</button>
          <button className="action-btn">Manage Users</button>
          <button className="action-btn">View Reports</button>
          <button className="action-btn">Settings</button>
        </div>
      </div>
    </div>
    </AdminLayout>
  );
};

export default AdminDashboard;
